/**
 * How long the "Joining session now..." interstitial shows before the client
 * is moved into the waiting room. Kept as a prop below so tests can shorten it.
 */
export const JOINING_TRANSITION_DURATION_MS = 3000;
